import { Module, RegisterOptions } from "vuex-class-modules";
import ListStoreVuex from "../../../../common/src/stores/general/ListStoreVuex";
import { Api } from "../../../../common/src/api/Api";
import {
    ConferenceListItem,
    ConferenceListResponse,
} from "@gsx/common/src/types/http/dashboard/conference";

@Module({ generateMutationSetters: true })
export class UserFavoriteConferenceListStore extends ListStoreVuex<ConferenceListItem> {
    constructor(private readonly api: Api, options: RegisterOptions) {
        super(options);
    }

    get filteredItemsByFutureDate(): ConferenceListItem[] {
        return (this.items || []).filter((conference) =>
            conference.endDate
                ? conference.endDate > new Date()
                : conference.startDate > new Date(),
        );
    }

    protected async fetch(): Promise<ConferenceListResponse> {
        return this.api.launchpad.userFavorites.conference.list();
    }
}
